import React, {useContext} from 'react';
import {MenuItem, TextField} from '@mui/material';
import FormControl from '@mui/material/FormControl';
import {BusinessUnitEnum, GlobalPermissionEnum} from '../../schema-types/globalTypes';
import {useDjangoContext} from '../../contexts/useAuthContext';
import ContactActionsContext from './ContactActionsContext';
import {useRTQ} from '../../hooks/useRTQ';

export const ContactActionsDropdown: React.FC<{contactId: string}> = ({contactId}) => {
  const {modalFlags, onSelect} = useContext(ContactActionsContext);
  const {perms, djangoUser} = useDjangoContext();
  const {atrName} = useRTQ();
  const notSppDaAndNotSppAr =
    djangoUser.businessUnit?.partnershipType !== BusinessUnitEnum.DA &&
    djangoUser.businessUnit?.partnershipType !== BusinessUnitEnum.AR;

  return (
    <FormControl id="contact-actions">
      <TextField
        select
        label="Actions"
        id="grouped-select"
        className="contact-actions-select"
        // placeholder="Select action"
        onChange={(e) => onSelect(contactId, e.target.value as any)}
        value={modalFlags.type}
      >
        <MenuItem value="empty">Actions</MenuItem>
        {perms.includes(GlobalPermissionEnum.can_access_cqs) ? (
          <MenuItem value="factfind">Manage FactFind</MenuItem>
        ) : null}
        {perms.includes(GlobalPermissionEnum.can_access_atrs) ? (
          <MenuItem value="atr">Manage {atrName}</MenuItem>
        ) : null}
        {perms.includes(GlobalPermissionEnum.can_access_admin_features) ? (
          <MenuItem value="notifications">Manage notifications</MenuItem>
        ) : null}
        {/* <MenuItem disabled value={2}> Send CQ</MenuItem> */}
        {/* {perms.includes(GlobalPermissionEnum.can_access_client_portal_FE) ? (
          <>
            <MenuItem value="notification">Send Client Portal Notification</MenuItem>
          </>
        ) : null} */}
        {/* FPA is temporarily disabled in production 
        ON-4054 - Remove the option to Send FPA from the Actions dropdown for SPP DA
        */}
        {perms.includes(GlobalPermissionEnum.can_access_fpa) && notSppDaAndNotSppAr ? (
          <MenuItem value="fpa">Manage FPA signature</MenuItem>
        ) : null}

        {perms.includes(GlobalPermissionEnum.can_access_fincalc) ? (
          <MenuItem value="fincalc">Launch Cashflow</MenuItem>
        ) : null}
        {/* <MenuItem disabled value={4}> Delete Notification </MenuItem> */}
      </TextField>
    </FormControl>
  );
};
